import axios from 'axios'

export default {
  downloadUrl (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/backup/get-download-url?key=${opts.key}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  recent (context, opts = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/backup/recent', { params: { scope: opts.scope } })
        .then(({ data }) => {
          context.commit('RECENT', data)
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  add (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/backup', opts)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  notify (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/backup/notify?system=${opts.system}&date=${opts.date}`)
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => reject(error))
    })
  },
  list (context, opts) {
    const options = opts ? { params: opts } : {}
    return new Promise((resolve, reject) => {
      axios
        .get('/api/backup', options)
        .then(({ data }) => {
          context.commit('LIST_SYSTEM', opts?.system)
          context.commit('LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ==========================Socket Updates==============================
  created (context, opts) {
    axios
      .get(`/api/backup/${opts}`)
      .then(({ data }) => {
        // 'backup' socket events are broadcast to the whole organization, so only add
        // the record if it belongs to the system whose list is currently loaded.
        if (data.id && data.system && data.system === context.state.system) {
          context.commit('LIST_ADD', data)
        }
      })
  },
  destroyed (context, opts) {
    console.log('destroyed')
    console.log(opts)
    context.commit('LIST_REMOVE', opts)
  }
}
